var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDangerAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2008 16.9992L14.6008 5.19922C14.1008 4.19922 13.1008 3.69922 12.0008 3.69922C10.9008 3.69922 9.90078 4.19922 9.40078 5.19922L2.80078 16.9992C2.30078 17.8992 2.30078 19.0992 2.80078 19.9992C3.30078 20.8992 4.30078 21.4992 5.40078 21.4992H18.6008C19.7008 21.4992 20.6008 20.8992 21.2008 19.9992C21.8008 19.0992 21.7008 17.9992 21.2008 16.9992ZM19.5008 18.9992C19.4008 19.0992 19.2008 19.4992 18.6008 19.4992H5.40078C4.90078 19.4992 4.60078 19.1992 4.50078 18.9992C4.40078 18.7992 4.20078 18.4992 4.50078 17.9992L11.1008 6.09922C11.4008 5.59922 11.8008 5.59922 12.0008 5.59922C12.2008 5.59922 12.6008 5.59922 12.9008 6.09922L19.5008 17.9992C19.7008 18.4992 19.5008 18.8992 19.5008 18.9992Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.5C11.4 9.5 11 9.9 11 10.5V13.5C11 14.1 11.4 14.5 12 14.5C12.6 14.5 13 14.1 13 13.5V10.5C13 9.9 12.6 9.5 12 9.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.5C12.5523 17.5 13 17.0523 13 16.5C13 15.9477 12.5523 15.5 12 15.5C11.4477 15.5 11 15.9477 11 16.5C11 17.0523 11.4477 17.5 12 17.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerAlert);
export default __webpack_public_path__ + "static/media/dangerAlert.436c7c89a35f7ddf4efb1d659fcad7e7.svg";
export { ForwardRef as ReactComponent };